/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductResponseDto } from './ProductResponseDto';
import {
    ProductResponseDtoFromJSON,
    ProductResponseDtoFromJSONTyped,
    ProductResponseDtoToJSON,
} from './ProductResponseDto';

/**
 * 
 * @export
 * @interface GetAllProducts200Response
 */
export interface GetAllProducts200Response {
    /**
     * 
     * @type {Array<ProductResponseDto>}
     * @memberof GetAllProducts200Response
     */
    data?: Array<ProductResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof GetAllProducts200Response
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllProducts200Response
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllProducts200Response
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllProducts200Response
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the GetAllProducts200Response interface.
 */
export function instanceOfGetAllProducts200Response(value: object): value is GetAllProducts200Response {
    return true;
}

export function GetAllProducts200ResponseFromJSON(json: any): GetAllProducts200Response {
    return GetAllProducts200ResponseFromJSONTyped(json, false);
}

export function GetAllProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllProducts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ProductResponseDtoFromJSON)),
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function GetAllProducts200ResponseToJSON(value?: GetAllProducts200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ProductResponseDtoToJSON)),
        'totalPages': value['totalPages'],
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'pageSize': value['pageSize'],
    };
}

